<script setup lang="ts">
import { QDialog } from 'quasar'
import { Color } from '@previo/codebooks'
import { PCardSize } from '../../card/types'
import { PSpaceSize } from '../../space/types'
import PCard from '../../card/PCard.vue'
import PSpace from '../../space/PSpace.vue'
import PBtn from '../../btn/PBtn.vue'
import { PBtnType } from '../../btn/types'

type Props = {
  showConfirmButtons?: boolean
}

type Emits = {
  (e: 'dismiss'): void
}

withDefaults(defineProps<Props>(), {
  showConfirmButtons: false,
})

const emits = defineEmits<Emits>()

const model = defineModel<boolean>()

const close = function () {
  model.value = false
}

const dismiss = function () {
  close()
  emits('dismiss')
}
</script>

<template>
  <q-dialog
    v-model="model"
    persistent
    maximized
    transition-show="slide-up"
    transition-hide="slide-down"
    data-cy="mobile-dropdown"
  >
    <p-card
      :color="Color.WHITE"
      class="ds-mobile-suggestion-dialog p-flex p-flex-direction-column p-no-wrap p-height-100-dvh"
    >
      <p-card :color="Color.WHITE" :pa-mobile="PCardSize.SM" class="p-flex no-wrap">
        <div class="p-full-width">
          <slot name="input" />
        </div>
        <p-space :mobile="PSpaceSize.SM" />
        <p-btn icon-end="xmark" :type="PBtnType.OUTLINE" cy="back" @click="dismiss()" />
      </p-card>

      <p-card
        :pa-mobile="PCardSize.SM"
        class="p-flex-1 p-flex p-flex-direction-column p-no-wrap p-min-height-0"
      >
        <slot name="default" />
      </p-card>

      <p-card v-if="showConfirmButtons" :pa-mobile="PCardSize.SM" class="p-display-flex">
        <p-btn :text="$t('Close')" :type="PBtnType.OUTLINE" cy="close" grow @click="close()" />
        <p-space :mobile="PSpaceSize.SM" />
        <p-btn :text="$t('Confirm')" :type="PBtnType.PRIMARY" cy="confirm" grow @click="close()" />
      </p-card>
    </p-card>
  </q-dialog>
</template>

<style lang="scss" scoped>
@import '../../../assets/scss/shared/mixins';

.ds-mobile-suggestion-dialog {
  @include safe-area-padding(top);
  @include safe-area-padding(right);
  @include safe-area-padding(bottom);
  @include safe-area-padding(left);
}
</style>
